<template>
	<div class="wrap-container-le">
		<div class="wrap-content-le">
			<div class="top-header-img">
				<!-- <img src="../assets/imgs/banner2.png" alt="" /> -->
				<img :src="topImg" alt="" />
			</div>
			<!-- 顶部 展示图 end -->

			<div class="center-more">
				<div>
					<div class="round-img-shelf">
						<img class="round-img-more-1" src="../assets/imgs/qiu1@2x.png" alt="" />
					</div>
					<div class="dividing-line"></div>
					<div class="center-more-label">
						<a name="#smart_title" id="smart_title"></a>
						<!-- 锚点1 -->
						<div class="title headline">{{ smartLighting_title.title }}</div>
						<div class="label small_caption mar-bottom">
							{{ smartLighting_title.subTitle }}
						</div>
						<div @click="gosmartProduct" class="more-btn hover-a mar-bottom92">
							查看更多
							<img src="../image/jiantou1.png" alt="" />
						</div>
					</div>
				</div>
			</div>

			<!-- 智能照明产品 展示 -->
			<div class="default-show-on" ref="optionscontent" id="optionscontent">
				<transition name="animate__fadeInUp" :appear="true" :duration="3000">
					<div class="show-on">
						<div class="left-show-on">
							<!-- <img
                src="../assets/imgs/wholeHouse.jpg"
                class="imgs-show"
                alt=""
              /> -->
							<div class="swiper_box">
								<swiper :options="defaultSwiper" ref="defaultSwiper" v-if="false">
									<swiper-slide
										class="swiper_slide swiper-no-swiping"
										v-for="(items, indexs) in lightingList"
										:key="indexs"
									>
										<!-- :style="'background-image: url(' + imgsShow + ')'" -->
										<div class="imgs-show" :style="'background-image: url(' + items.banner + ')'">
											<div class="list-content-box">
												<div
													class="options-content"
													id="refs-options"
													@mousemove="onmousemove($event)"
												>
													<div
														class="float-label"
														v-for="(item, index) in lightingLists"
														:key="index"
														@click="lightNum = index"
														@mouseover="lightNum = index"
														@mouseleave="lightNum = -1"
														:style="`top: calc(var(--proportion) * ${item.y_axis}px);left: calc(var(--proportion) * ${item.x_axis}px);`"
													>
														<div class="info-form" v-show="lightNum == index">
															<div class="info-form-img">
																<img :src="item.image_text" alt="" />
															</div>
															<div class="info-form-label">
																<div class="title">{{ item.name }}</div>
																<a :href="item.product_url" target="black" class="more-info-form">
																	查看详情
																</a>
															</div>
														</div>
														<div class="round-btn"></div>
														<div
															class="label"
															:style="`position: relative; ${
																item.x_axis > 1180
																	? 'top: calc(var(--proportion) * 40px); left: calc(var(--proportion) * -50px) '
																	: ''
															}`"
														>
															{{ item.name }}
														</div>
													</div>
												</div>
											</div>
										</div>
									</swiper-slide>
								</swiper>

								<el-carousel
									ref="carousel"
									arrow="never"
									:autoplay="false"
									indicator-position="none"
								>
									<el-carousel-item
										class="swiper_slide"
										v-for="(items, indexs) in lightingList"
										:key="indexs"
									>
										<div
											class="imgs-show"
											:style="'background-image: url(' + items.banner + ')'"
										></div>
									</el-carousel-item>
								</el-carousel>
							</div>
							<div class="list-content-box">
								<div class="options-content" id="refs-options" @mousemove="onmousemove($event)">
									<div
										class="float-label"
										v-for="(item, index) in lightingLists"
										:key="index"
										@click="lightNum = index"
										@mouseover="lightNum = index"
										@mouseleave="lightNum = -1"
										:style="`top: calc(var(--proportion) * ${item.y_axis}px);left: calc(var(--proportion) * ${item.x_axis}px);`"
									>
										<!-- lightNum == index -->
										<div class="info-form" v-show="lightNum == index">
											<div class="info-form-img">
												<img :src="item.image_text" alt="" />
											</div>
											<div class="info-form-label">
												<div class="title">{{ item.name }}</div>
												<a :href="item.product_url" target="black" class="more-info-form">
													查看详情
												</a>
											</div>
										</div>
										<div class="round-btn"></div>
										<div
											class="label"
											:style="`position: relative; ${
												item.x_axis > 1180
													? 'top: calc(var(--proportion) * 40px); left: calc(var(--proportion) * -50px) '
													: ''
											}`"
										>
											{{ item.name }}
										</div>
									</div>
								</div>
							</div>

							<div class="show-on-bottom">
								<el-tabs v-model="activeRoomType" @tab-click="handleClickRoomType">
									<el-tab-pane
										:label="item.name"
										:name="index.toString()"
										v-for="(item, index) in lightingList"
										:key="index"
									>
									</el-tab-pane>
									<!-- <el-tab-pane label="全屋" name="first"></el-tab-pane>
                    <el-tab-pane label="客厅" name="second"></el-tab-pane>
                    <el-tab-pane label="卧室" name="third"></el-tab-pane>
                    <el-tab-pane label="书房" name="fourth"></el-tab-pane> -->
								</el-tabs>
							</div>
						</div>
						<div class="right-show-on">
							<div class="right-show-title">产品清单</div>
							<div class="product-show-list">
								<div
									class="show-content-list"
									:class="{
										none: rigthList.length <= 6,
									}"
								>
									<div class="show-product-item" v-for="(item, index) in rigthList" :key="index">
										<a class="product-item-a" :href="item.product_url" target="black">
											<div class="product-item-left">
												<div class="title">{{ item.name }}</div>
												<div class="num">×{{ item.quantity }}</div>
											</div>
											<div class="product-item-right">
												<img :src="item.image_text" alt="" />
											</div>
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</transition>
			</div>

			<!-- 中间产品展示 end -->
			<div class="material-download">
				<img class="material-download-img" src="../assets/imgs/qiu2.png" alt="" />
				<a name="#dasgin_title" id="dasgin_title"></a>
				<div class="material-download-shelf wow animate__animated animate__fadeInUp">
					<div class="material-download-title">
						<div class="dividing-line"></div>

						<!-- 锚点2 -->
						<div class="title headline">设计素材下载</div>
						<div class="label small_caption"> 汇聚符合打单场景的素材，可查看、下载与应用 </div>
						<div class="tag-shelf">
							<el-tabs v-model="activeNameMaterial" @tab-click="handleClickMaterial">
								<el-tab-pane
									:label="item.name"
									:name="index + ''"
									v-for="(item, index) in downloadList"
									:key="index"
								>
								</el-tab-pane>
							</el-tabs>
						</div>
					</div>
					<div class="material-list" v-if="downloadList.length > 0">
						<div class="material-content" v-if="downloadList[activeNameMaterial].type == '1'">
							<div
								class="material-item"
								@mouseover="onBindMaterialMouse(index)"
								@mouseout="onBindMaterialMouseout"
								v-for="(item, index) in downloadList[activeNameMaterial].value"
								:key="index"
							>
								<img
									:class="{
										hover: index === materialDownloadIndex,
									}"
									class="transition_effect"
									:src="item.banner_text"
									alt=""
								/>

								<!-- 鼠标移入蒙版 -->
								<div v-show="index === materialDownloadIndex" class="material-item-popup">
									<div class="item-popup-title">{{ item.title }}</div>
									<div
										class="btn-download hover-a"
										@click="goDownload(item, item.appendix_file_name || '素材文件')"
									>
										下载
										<img class="btn-download-img" src="../assets/imgs/xiazai@2x.png" alt="" />
									</div>
								</div>
								<!-- 标题 -->
								<div
									v-show="!(index === materialDownloadIndex)"
									class="material-item-popup material-item-popup2"
								>
									<p class="item-popup-title">{{ item.title }}</p>
								</div>
							</div>
						</div>

						<!-- 视频 -->
						<div class="material-content" v-show="downloadList[activeNameMaterial].type == '2'">
							<div
								class="material-video-item"
								@mouseover="mouseoverMaterialVideo(index)"
								@mouseout="mouseoutMaterialVideo"
								v-for="(item, index) in downloadList[activeNameMaterial].value"
								:key="index"
							>
								<div class="material-video-img">
									<img class="video-img transition_effect" :src="item.banner_text" />
									<div class="open-popup" v-show="index === materialVideoIndex">
										<img src="../assets/imgs/bf@2x.png" @click="onBindOpenVideo(item)" alt="" />
									</div>
								</div>
								<div class="material-video-title">{{ item.title }}</div>
								<div class="material-video-label">
									{{ item.desc }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 设计下载 end-->

			<!-- 设计案例分享 -->
			<div class="material-share wow animate__animated animate__fadeInUp">
				<a name="#dasgin_share" id="dasgin_share" ref="dasgin_share"></a>
				<div class="dividing-line"></div>
				<!-- 锚点3 -->
				<div class="title headline">
					{{ shareText[0] ? shareText[0].name : '设计案例分享' }}
				</div>
				<div class="label small_caption mar-bottom">
					{{ shareText[0] ? shareText[0].vice_name : '工程与家装领域佳作，带你领略光的魅力与价值' }}
				</div>
				<div class="material-share-list">
					<div class="list_box">
						<div
							class="material-share-item"
							ref="material_item"
							v-for="(item, index) in shareList"
							@mouseover="mouseoverMaterialShare(index)"
							@mouseout="mouseoutMaterialShare"
							@click="gocase_details(item.id)"
							:key="index"
						>
							<div class="container-share-item">
								<div class="material-share-img">
									<img
										class="share-img"
										:class="{
											hover: index === materialShareIndex,
										}"
										:src="item.banner_text"
									/>
									<div class="material-share-popup" v-show="index === materialShareIndex">
										<div class="title">{{ item.title }}</div>
										<div class="btn-download hover-a">
											查看详情
											<img class="btn-download-img" src="../assets/imgs/jiantoubai@2x.png" alt="" />
										</div>
									</div>
								</div>
								<div class="material-share-title">{{ item.title }}</div>
								<div class="material-share-label">
									{{ item.subtitle }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 设计案例分享 end -->

		<div class="video-shelf wow animate__animated animate__fadeInUp" v-if="openVideo">
			<img
				class="video-shelf-close"
				@click="closeVideo"
				src="../assets/icon/red_close.png"
				alt=""
			/>
			<video
				class="video"
				controls="controls"
				autoplay
				loop
				controlsList="nodownload"
				:src="videoLink"
			></video>
		</div>

		<!-- 下载 -->
		<el-dialog :title="downloadTextShow" :visible.sync="dialogDownload" @close="dialogClose">
			<div class="down-shelf-text">
				<div class="down-rogress">{{ fileName_i }} - 当前进度</div>
				<el-progress
					:text-inside="true"
					:stroke-width="24"
					:color="colorStatus[statusLoading]"
					:percentage="pro_percentage"
					status="success"
				></el-progress>
			</div>
		</el-dialog>

		<div
			class="small-skylight"
			v-if="!dialogDownload && is_currentDownload"
			@click="dialogDownload = true"
		>
			<el-progress
				:color="colorStatus[statusLoading]"
				type="circle"
				:percentage="pro_percentage"
			></el-progress>
		</div>
		<!-- 下载 end -->

		<!-- 坐标框 -->
		<!-- <div
      class="fied-box"
      :style="`top:${boxtop - 10}px;left:${boxleft + 10}px`"
    >
      <div>{{ boxinfo.top }}</div>
      <div>{{ boxinfo.left }}</div>
      <div>{{ boxinfo.content }}</div>
    </div> -->
	</div>
</template>

<script>
	import {
		$smartProduct,
		$materialDownload,
		$designShare,
		$productImage,
		$indexTitle,
		$productDownloadCount,
	} from '../api/index';
	import { swiper, swiperSlide } from 'vue-awesome-swiper';
	import 'swiper/dist/css/swiper.css';
	import axios from 'axios';
	export default {
		data() {
			return {
				topImg: '',

				smartLighting_title: {},
				a1: 0,
				anchor: '', // 锚点
				boxinfo: {
					top: 'top:0px',
					left: 'left: 0px',
					content: '',
				},
				imgsShow: '',
				lightingLists: [],
				rigthList: [],
				boxtop: 0,
				boxleft: 0,
				activeRoomType: '0',
				activeNameMaterial: '0',
				loadingShow: false,
				materialDownloadIndex: '',
				materialShareIndex: '',
				materialVideoIndex: '',

				openVideo: false,
				videoLink: '', //視頻地址

				lightingList: [], //照明列表
				downloadList: [], //下載列表
				shareList: [], //分享列表
				shareText: '',
				offLightList: [
					[],
					[
						{ top: '282', left: '268' },
						{ top: '294', left: '560' },
						{ top: '240', left: '810' },
						{ top: '262', left: '1070' },
						{ top: '467', left: '286' },
						{ top: '420', left: '700' },
						{ top: '502', left: '876' },
						{ top: '353', left: '1052' },
						// 全屋 8个 开关按钮
						{ top: '350', left: '310' },
						{ top: '370', left: '400' },
						{ top: '200', left: '980' },
					],
				], //灯带点击列表
				lightNum: -1, //点亮灯的序号

				defaultSwiper: {
					initialSlide: 0, // 初始化 索引
				},

				initialIndex: 0,

				// 下载提示
				fileName_i: '',
				statusLoading: 'down',
				colorStatus: {
					down: '#f56c6c',
					bale: '#e60000',
				},
				// 显示下载 弹窗
				dialogDownload: false,
				// 当前是否有下载
				is_currentDownload: false,
				// 弹窗提示
				downloadTextShow: '正在下载',
				// 当前进度
				pro_percentage: 0,
			};
		},
		beforeCreate() {},
		created() {
			this.getTopImg();
			this.smartProduct(); // 智能照明列表
		},
		beforeMount() {},
		mounted() {
			let doms = this.$refs;
			// let doms = this.$refs['material_item'];
			this.getindexText();
			this.$nextTick(() => {
				// 锚点
				let timers = setInterval(() => {
					if (
						doms['dasgin_share'] &&
						doms['material_item'] &&
						doms['material_item'].length == this.shareList.length
					) {
						this.getAnchor();
						clearInterval(timers);
					}
				}, 400);
			});

			// this.$nextTick(() => { // 锚点
			//   setTimeout(() => {
			//     this.getAnchor();
			//   }, 1000);
			// });

			// this.smartProduct(); // 智能照明列表
			new this.$wow.WOW({
				boxClass: 'wow',
				animateClass: 'animate__animated',
				offset: 0,
				mobile: true,
				live: true,
			}).init();
		},
		beforeUpdate() {},
		updated() {},
		beforeDestroy() {},
		destroyed() {
			clearTimeout(this.$data.timer);
		},
		components: {
			swiper,
			swiperSlide,
		},
		methods: {
			//获取案例分享文字
			getindexText() {
				$indexTitle({
					ids: 18,
				}).then((res) => {
					// console.log(res);
					this.shareText = res.data;
				});
			},
			// 获取顶部图
			getTopImg() {
				$productImage()
					.then((res) => {
						// console.log('获取顶部图', res);
						this.topImg = res.data.image;
					})
					.catch((err) => {
						console.log(err);
					});
			},

			//下载素材
			async goDownload(file, file_title, title, file_suffix) {
				const token = this.$store.state.checked
					? this.$store.state.userInfo.token
					: sessionStorage.getItem('cdntoken');
				if (!token) {
					this.$message.error({ message: `未登录不可下载`, showClose: true });
					return;
				}
				$productDownloadCount({
					id: file.id,
				});
				// console.log(file, title, "---------", subtitle);
				// return
				if (file) {
					const parmas = {
						url: file.appendix_text,
						size: 1024 ** 2 * 100,
					};

					// let a = document.createElement("a");
					// a.download = 'subtitle';
					// a.href = file;
					// a.target = "_blank";
					// a.click();

					// let params = [file];
					// this.$refs.downzip
					//     .onDownload(`${file_title || title}`, params)
					//     .then(() => {
					//       // return this.$refs.downzip.onDownload(
					//       //   `${file_title || title}`,
					//       //   params
					//       // );
					//     })
					//     // .then(() => {});

					// 下载提示 初始化

					this.$singleDownLoad(parmas, file_title);

					// this.fileName_i = title;
					// this.statusLoading = "down";
					// this.dialogDownload = true;
					// this.is_currentDownload = true;
					// this.pro_percentage = 0;

					// const promise = await this.getFile(file, (ing) => {
					//   let complete = parseInt((ing.loaded / ing.total) * 100);
					//   this.pro_percentage = complete;
					// });

					// FileSaver.saveAs(promise, `${file_title || title + file_suffix}`); // 保存文件  修改名称

					// // 下载 结束
					// this.statusLoading = "bale";
					// this.dialogDownload = false;
					// this.is_currentDownload = false;
				}
			},
			/**
			 * 获取文件
			 * @param url 文件路径
			 * @returns {Promise<unknown>}
			 */
			async getFile(url, loading) {
				return await new Promise((resolve, reject) => {
					axios({
						method: 'get',
						url,
						responseType: 'blob',
						// responseType: 'arraybuffer'
						onDownloadProgress: (progressEvent) => {
							if (loading) {
								loading(progressEvent);
							}
						},
					})
						.then((data) => {
							resolve(data.data);
						})
						.catch((error) => {
							reject(error.toString());
						});
				});
			},

			dialogClose() {
				this.dialogDownload = false;
				if (this.is_currentDownload) {
					this.$message.error({
						message: '文件正在下载,请勿关闭当前页面',
						showClose: true,
					});
				}
			},

			// 锚点
			getAnchor() {
				let anchor = this.$route.hash.slice(1);
				let doms = document.getElementById(anchor);
				if (!doms) return;
				doms.scrollIntoView(true);
			},

			handleClickRoomType(tab, event) {
				let index = this.activeRoomType;
				this.imgsShow = this.lightingList[index].banner;
				this.lightingLists = this.lightingList[index].list;
				this.rigthList = this.lightingList[index].right_list;
				// console.log('图片地址', this.imgsShow);

				// 轮播图切换
				// this.$refs.defaultSwiper.swiper.slideTo(tab.name, 1000, false);//切换到第一个index，速度为1秒

				// elementUI
				this.initialIndex = Number(tab.name);
				this.$refs.carousel.setActiveItem(this.initialIndex);
			},
			onmousemove(ev) {
				this.boxleft = ev.clientX + 10;
				this.boxtop = ev.clientY - 10;
				this.boxinfo = {
					top: `top:${ev.clientY}px`,
					left: `left:${ev.clientX}px`,
					content: `x${ev.x},y${ev.y}`,
				};
			},

			//智能照明列表
			smartProduct() {
				$smartProduct()
					.then((res) => {
						let index = this.activeRoomType;
						this.smartLighting_title = {
							title: res.data.title.name,
							subTitle: res.data.title.vice_name,
						};
						// console.log('智能照明列表', res.data.data);
						this.lightingList = res.data.data;
						this.imgsShow = res.data.data[index].banner;
						this.lightingLists = res.data.data[index].list;
						this.rigthList = res.data.data[index].right_list;
						// console.log('智能照明列表', res.data['0'], this.imgsShow);
						// 设计素材下载
						return $materialDownload();
					})
					.then((res) => {
						// console.log('设计素材下载', res.data);
						this.downloadList = res.data;

						return $designShare();
					})
					.then((res) => {
						// console.log(res, "nihao1");
						this.shareList = res.data;
					});
			},
			gocase_details(id) {
				this.$router.push('/case_details?id=' + id);
			},
			gosmartProduct() {
				this.$router.push('/smart_product');
			},
			handleClickMaterial(tab, event) {
				// console.log(this.activeNameMaterial);
				// console.log(tab, event);
			},

			// 产品清单
			productItemChange(url) {
				// console.log("产品清单", url);
			},

			onBindMaterialMouse(el) {
				this.materialDownloadIndex = el;
			},
			onBindMaterialMouseout() {
				this.materialDownloadIndex = '';
			},

			mouseoverMaterialShare(el) {
				this.materialShareIndex = el;
			},
			mouseoutMaterialShare() {
				this.materialShareIndex = '';
			},
			mouseoverMaterialVideo(el) {
				this.materialVideoIndex = el;
			},
			mouseoutMaterialVideo() {
				this.materialVideoIndex = '';
			},
			onBindOpenVideo(video) {
				this.openVideo = true;
				this.videoLink = video.appendix_text;
				$productDownloadCount({
					id: video.id,
				});
			},
			closeVideo() {
				this.openVideo = false;
			},
		},
		watch: {
			// 当前路由改变 切换锚点
			$route(val, oldVal) {
				this.getAnchor();
			},
		},
	};
</script>

<style lang="scss" scoped>
	.fied-box {
		position: fixed;
		z-index: 999;
		min-width: 100px;
		min-height: 100px;
		font-size: 12px;
		background-color: #fff;
	}
	.wrap-container-le {
		position: relative;
		box-sizing: border-box;
		width: 100%;
		min-width: 1100px;
		min-height: 100vh;
		background-color: RGBA(16, 15, 15, 1);

		.wrap-content-le {
			width: 100%;

			.top-header-img {
				position: relative;
				width: 100%;

				img {
					width: 100%;
				}
			}

			.center-more {
				position: relative;
				display: inline-block;
				// overflow: hidden;
				width: 100%;
				// height: calc(var(--proportion) * 287px);

				// border: 1px solid #fff;
				.round-img-shelf {
					position: absolute;
					top: calc(var(--proportion) * -10px);
					right: 0px;
					width: 65%;
					overflow: hidden;
					height: calc(var(--proportion) * 860px);
				}

				.round-img-more-1 {
					position: absolute;
					top: 0px;
					right: 0px;
					z-index: 0;
					transform: translateX(58%);
					width: calc(var(--proportion) * 1252px * 2.35);
					height: calc(var(--proportion) * 860px);
				}

				.center-more-label {
					position: relative;
					z-index: 4;
					text-align: center;

					.title {
						font-size: 1.45rem;
						width: 100%;
						line-height: 1;

						color: #ffffff;
						font-weight: 500;
						opacity: 0.85;
						margin-bottom: calc(var(--proportion) * 24px);
					}

					.label {
						font-size: 0.84rem;
						font-weight: 500;
						color: #ffffff;
						opacity: 0.5;
						line-height: 1;
					}
				}

				.more-btn {
					margin: 0px auto;
					margin-top: calc(var(--proportion) * 30px);
					margin-bottom: calc(var(--proportion) * 48px);
					display: flex;
					justify-content: center;
					align-items: center;
					width: calc(var(--proportion) * 155px);
					height: calc(var(--proportion) * 48px);
					border: 1px solid rgba(255, 255, 255, 0.85);
					font-size: 0.42rem;

					font-weight: 400;
					// color: rgba(255, 255, 255, 0.85);
					color: #fff;
					cursor: pointer;
					&:hover {
						color: rgba(255, 255, 255, 1);
						// color: #000;
					}

					img {
						position: relative;
						left: 7px;
						width: calc(var(--proportion) * 12px);
						height: calc(var(--proportion) * 12px);
					}
				}
			}

			.default-show-on {
				position: relative;
				z-index: 2;
				width: 100%;
				height: calc(var(--proportion) * 800px);
			}

			.show-on {
				position: relative;
				z-index: 4;
				display: flex;
				justify-content: center;
				align-items: center;
				width: 100%;
				height: calc(var(--proportion) * 800px);

				.left-show-on {
					position: relative;
					width: calc(var(--proportion) * 1350px);
					height: 100%;

					.left-top-box {
						position: absolute;
					}

					.imgs-show {
						position: relative;
						// transform: scale(var(--proportion));
						background-size: 100% 100%;
						/*按比例缩放*/
						background-repeat: no-repeat;
						// overflow: hidden;
						background-size: 100% 100%;
						// width: 1350px;
						// height: 800px;
						width: calc(var(--proportion) * 1350px);
						height: 100%;
					}
					.list-content-box {
						position: absolute;
						top: 0;
						right: 0;
						bottom: 0;
						left: 0;
						z-index: 9999;
					}

					.options-content {
						position: relative;
						width: 100%;
						height: 100%;

						.info-form {
							position: absolute;
							// top: calc(var(--proportion) * -158px);
							top: calc(var(--proportion) * -148px);
							left: 0px;
							z-index: 99999;
							box-sizing: border-box;
							padding: calc(var(--proportion) * 24px);
							display: flex;
							justify-content: flex-start;
							align-items: center;
							width: calc(var(--proportion) * 352px);
							height: calc(var(--proportion) * 148px);
							background: rgba(255, 255, 255, 0.9);

							.info-form-img {
								flex-grow: 0;
								flex-shrink: 1;
								margin-right: calc(var(--proportion) * 24px);
								// width: calc(var(--proportion) * 100px);
								// height: calc(var(--proportion) * 100px);
								width: 100px;
								height: 100px;
								display: flex;
								justify-content: center;
								align-items: center;
								// padding: 25px;
								padding: calc(var(--proportion) * 10px);
								box-sizing: border-box;

								img {
									max-height: 100%;
									max-width: 100%;
								}
							}

							.info-form-label {
								position: relative;
								flex-grow: 0;
								box-sizing: border-box;
								padding-left: calc(var(--proportion) * 24px);
								border-left: 1px solid #999999;
								height: calc(var(--proportion) * 100px);

								.title {
									font-size: 0.61rem;

									// font-weight: bold;
									color: #333333;
									line-height: 0.97rem;
									@include wrap_line(2);
								}

								.more-info-form::after {
									content: '';
									position: relative;
									top: calc(var(--proportion) * 1px);
									left: calc(var(--proportion) * 7px);
									width: calc(var(--proportion) * 12px);
									height: calc(var(--proportion) * 12px);
									background: url('../assets/imgs/jiantou1@2x.png') no-repeat;
									background-size: 100%;
								}

								.more-info-form:hover::after {
									background: url('../assets/imgs/jiantou1 2@2x.png') no-repeat;
									background-size: 100%;
								}

								.more-info-form:hover {
									cursor: pointer;
									color: #e60000 !important;
								}

								.more-info-form {
									position: absolute;
									bottom: 0px;
									left: calc(var(--proportion) * 24px);
									display: flex;
									justify-content: center;
									align-items: center;

									font-size: 0.42rem;

									font-weight: 400 !important;
									color: #666666 !important;

									img {
										position: relative;
										left: 7px;
										width: calc(var(--proportion) * 12px);
										height: calc(var(--proportion) * 12px);
									}
								}
							}
						}

						.float-label:hover {
							.round-btn::before {
								animation-duration: 1.2s;
							}
							.label {
								animation-name: fade-in;
								animation-duration: 2.2s;
								animation-timing-function: normal;
								animation-delay: 0s;
								animation-iteration-count: infinite;
								animation-direction: alternate-reverse;
								animation-fill-mode: none;
							}
							@keyframes fade-in {
								0% {
									opacity: 0.73;
								}
								100% {
									opacity: 1;
								}
							}
						}
						.float-label {
							position: absolute;
							top: 140px;
							left: 0px;
							display: flex;
							align-items: center;
							width: calc(var(--proportion) * 240px);
							height: calc(var(--proportion) * 40px);

							padding-top: 10px;
							margin-top: -10px;

							.round-btn::before {
								--widthandheight: calc(var(--proportion) * 30px);
								content: '';
								position: absolute;
								top: calc(50% - (var(--widthandheight) / 2));
								left: calc(50% - (var(--widthandheight) / 2));
								width: var(--widthandheight);
								height: var(--widthandheight);
								border-radius: 50%;
								background: rgba(255, 255, 255, 0.2);

								animation-name: scale-up-center;
								animation-duration: 2.2s;
								animation-timing-function: ease;
								animation-delay: 0s;
								animation-iteration-count: infinite;
								animation-direction: alternate-reverse;
								animation-fill-mode: none;
							}
							@keyframes scale-up-center {
								0% {
									// transform: scale(0.2);
									// filter: blur(12px);
									// opacity: 0;
									transform: scale(0.9);
									filter: blur(5px);
									opacity: 0.9;
								}
								100% {
									transform: scale(1.1);
									filter: blur(0);
									opacity: 1;
								}
							}
							.round-btn {
								margin-right: calc(var(--proportion) * 10px);
								display: flex;
								justify-content: center;
								align-items: center;
								position: relative;
								width: calc(var(--proportion) * 40px);
								height: calc(var(--proportion) * 40px);
								border-radius: 50%;
							}
							.round-btn:hover {
								cursor: pointer;
							}

							.round-btn::after {
								content: '';
								width: calc(var(--proportion) * 16px);
								height: calc(var(--proportion) * 16px);
								border-radius: 50%;
								background-color: #fff;
							}

							.label {
								box-sizing: border-box;
								padding: calc(var(--proportion) * 12px) calc(var(--proportion) * 20px);
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;
								word-wrap: nowrap;
								line-height: 1;
								font-size: 0.42rem;

								font-weight: 400;
								color: rgba(255, 255, 255, 0.8);
								// width: calc(var(--proportion) * 189px);
								height: calc(var(--proportion) * 40px);
								background: rgba(19, 17, 17, 0.8);
								border-radius: calc(var(--proportion) * 20px);
							}
						}
					}
				}

				.right-show-on {
					width: calc(var(--proportion) * 570px);
					height: 100%;
					background: #252525;

					.right-show-title {
						margin: calc(var(--proportion) * 30px) 0px;
						margin-top: calc(var(--proportion) * 40px);
						text-align: center;
						font-size: 0.61rem;

						// font-weight: bold;
						color: #ffffff;
					}

					.product-show-list {
						box-sizing: border-box;
						padding: 0px calc(var(--proportion) * 70px);
						padding-right: calc(var(--proportion) * 60px);
						width: 100%;
						height: calc(var(--proportion) * 630px);

						.show-content-list {
							width: 100%;
							height: 100%;
							overflow-y: scroll;
							overflow-x: visible;

							.show-product-item {
								display: flex;
								justify-content: flex-start;
								align-items: center;

								padding: calc(var(--proportion) * 16px) 0px;
								width: calc(var(--proportion) * 338px);
								height: calc(var(--proportion) * 104px);
								box-shadow: 0px 1px 0px 0px rgba(255, 255, 255, 0.2);
								a {
									cursor: pointer;
									&:hover {
										// background: rgba(230, 50, 65, 0.1);
										background: rgba(99, 99, 99, 0.1);
									}
								}
								// &:hover {
								//   // background: rgba(230, 50, 65, 0.1);
								//   background: rgba(99, 99, 99, 0.1);
								// }
								.product-item-a {
									width: 100%;
									display: flex;
									justify-content: flex-start;
									align-items: center;
								}

								.product-item-left {
									flex-grow: 1;

									.title {
										font-size: 0.49rem;

										font-weight: 500;
										color: rgba(255, 255, 255, 0.85);
										margin-bottom: calc(var(--proportion) * 12px);
									}

									.num {
										font-size: 0.49rem;

										font-weight: 400;
										color: rgba(255, 255, 255, 0.3);
									}
								}

								.product-item-right {
									flex-shrink: 0;
									display: flex;
									justify-content: center;
									align-items: center;
									width: calc(var(--proportion) * 72px);
									height: calc(var(--proportion) * 72px);
									img {
										max-width: 100%;
										max-height: 100%;
									}
								}
							}
						}

						.show-content-list.none {
							overflow-y: visible;
						}

						.show-content-list::-webkit-scrollbar {
							/*滚动条整体样式*/
							width: 4px;
							/*高宽分别对应横竖滚动条的尺寸*/
							height: 1px;
						}

						.show-content-list::-webkit-scrollbar-thumb {
							/*滚动条里面小方块*/
							border-radius: 10px;
							box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
							background: #e60000;
							cursor: pointer;
						}

						.show-content-list::-webkit-scrollbar-track {
							/*滚动条里面轨道*/
							box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
							border-radius: 10px;
							background: rgba(255, 255, 255, 0.1);
						}
					}
				}
			}
		}
	}

	.show-on .show-on-bottom {
		position: absolute;
		z-index: 9999;
		bottom: calc(-10px / var(--proportion));
		left: 0px;
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		// height: calc(var(--proportion) * 114px);
		height: 114px;
		// border: 1px solid #000;

		::v-deep .el-tabs__nav-wrap::after {
			background-color: transparent !important;
		}

		::v-deep .el-tabs__item {
			position: relative;
			z-index: 4;
			padding: 0 40px;
			font-size: 24px;
			font-family: Alibaba PuHuiTi 2;
			font-weight: normal;
			color: rgba(255, 255, 255, 0.85) !important;
		}

		::v-deep .el-tabs__active-bar {
			bottom: 2px;
			height: 4px;
			background: #e60000;
		}
	}

	.material-download {
		position: relative;
		width: 100%;
		// height: calc(var(--proportion) * 1060px); // --

		.material-download-img {
			position: absolute;
			top: calc(var(--proportion) * -130px);
			left: 0px;
			z-index: 0;
			width: 100%;
			height: calc(var(--proportion) * 1000px);
		}

		.material-download-shelf {
			position: relative;
			z-index: 4;
			width: 100%;
			height: 100%;

			.material-download-title {
				position: relative;
				z-index: 4;
				display: inline-block;
				width: 100%;
				// height: calc(var(--proportion) * 425px);
				text-align: center;

				.title {
					font-size: 1.45rem;
					width: 100%;
					line-height: 1.45rem;

					color: #ffffff;
					font-weight: 500;
					opacity: 0.85;
					margin-bottom: calc(var(--proportion) * 24px);
				}

				.label {
					font-size: 0.84rem;
					line-height: 0.84rem;

					font-weight: 500;
					color: #ffffff;
					opacity: 0.5;
					// margin-bottom: calc(var(--proportion) * 30px);
					margin-bottom: calc(var(--proportion) * (91px - 15px)) !important;
				}

				.dividing-line {
					margin-top: calc(var(--proportion) * 120px);
					margin-bottom: calc(var(--proportion) * 32px);
				}

				.tag-shelf {
					margin-top: calc(var(--proportion) * 14px);
					display: flex;
					justify-content: center;
					align-items: center;
					width: 100%;
					margin-bottom: calc(var(--proportion) * 48px);

					::v-deep .el-tabs__nav-wrap::after {
						background-color: transparent !important;
					}

					::v-deep .el-tabs__item {
						position: relative;
						z-index: 4;
						padding: 0 40px;
						font-size: 24px;
						font-family: Alibaba PuHuiTi 2;
						font-weight: normal;
						color: rgba(255, 255, 255, 0.85) !important;
					}

					::v-deep {
						.el-tabs__nav-wrap,
						.el-tabs__nav-scroll {
							overflow: visible;
						}
					}

					::v-deep .el-tabs__active-bar {
						bottom: 2px;
						height: 4px;
						background: #e60000;
					}
				}
			}
		}
	}

	.material-download .material-list {
		padding: 0px calc(var(--proportion) * 60px);
		box-sizing: border-box;
		width: 100%;
		// height: calc(var(--proportion) * 632px); // --
		// margin-bottom: 40px;

		.material-content {
			display: flex;
			justify-content: flex-start;
			align-items: flex-end;
			overflow-x: scroll;
			overflow-y: visible;
			width: 100%;
			// height: 100%; // --
		}

		.material-content::-moz-scrollbar {
			/*滚动条整体样式*/
			width: 4px;
			/*高宽分别对应横竖滚动条的尺寸*/
			height: 4px;
		}
		.material-content::-o-scrollbar {
			/*滚动条整体样式*/
			width: 4px;
			/*高宽分别对应横竖滚动条的尺寸*/
			height: 4px;
		}
		.material-content::-webkit-scrollbar {
			/*滚动条整体样式*/
			width: 4px;
			/*高宽分别对应横竖滚动条的尺寸*/
			height: 4px;
		}

		.material-content::-moz-scrollbar-thumb {
			/*滚动条里面小方块*/
			border-radius: 10px;
			box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
			background: #e60000;
			cursor: pointer !important;
		}
		.material-content::-o-scrollbar-thumb {
			/*滚动条里面小方块*/
			border-radius: 10px;
			box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
			background: #e60000;
			cursor: pointer !important;
		}
		.material-content::-webkit-scrollbar-thumb {
			/*滚动条里面小方块*/
			border-radius: 10px;
			box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
			background: #e60000;
			cursor: pointer !important;
		}

		.material-content::-moz-scrollbar-track {
			/*滚动条里面轨道*/
			box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
			border-radius: 10px;
			background: rgba(255, 255, 255, 0.1);
		}
		.material-content::-o-scrollbar-track {
			/*滚动条里面轨道*/
			box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
			border-radius: 10px;
			background: rgba(255, 255, 255, 0.1);
		}
		.material-content::-webkit-scrollbar-track {
			/*滚动条里面轨道*/
			box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
			border-radius: 10px;
			background: rgba(255, 255, 255, 0.1);
		}

		.material-item {
			position: relative;
			margin: 0px calc(var(--proportion) * 12px);
			margin-bottom: 40px;
			overflow: hidden;
			width: calc(var(--proportion) * 440px);
			height: calc(var(--proportion) * 592px);
			flex-shrink: 0;

			img.hover {
				transform: scale(1.1);
			}

			img {
				width: 100%;
				height: 100%;
			}

			.material-item-popup {
				position: absolute;
				top: 0px;
				left: 0px;
				z-index: 4;
				display: flex;
				justify-content: center;
				align-items: center;
				flex-direction: column;
				width: 100%;
				height: 100%;
				background: rgba(0, 0, 0, 0.5);

				.item-popup-title {
					text-align: center;
					// font-size: 1.1rem;
					font-size: 0.85rem;
					padding: 0 24px;

					// font-weight: bold;
					color: rgba(255, 255, 255, 0.85);
				}

				// .btn-download:hover {
				//   opacity: 0.9;
				// }

				.btn-download {
					margin-top: calc(var(--proportion) * 29px);
					display: flex;
					justify-content: center;
					align-items: center;
					width: calc(var(--proportion) * 114px);
					height: calc(var(--proportion) * 48px);
					// background: #e60000;

					border: 1px solid #ffffff;
					// opacity: 0.85;

					font-size: calc(var(--proportion) * 16px);
					font-weight: 500;
					color: #ffffff;
					cursor: pointer;

					.btn-download-img {
						margin-left: 7px;
						width: 11px;
						height: 12px;
					}
				}
			}
			.material-item-popup2 {
				width: 100%;
				background: none;
				justify-content: flex-end;

				.item-popup-title {
					width: 100%;
					padding: 24px;
					padding-bottom: calc(24px - (36px - 24px) / 2);
					box-sizing: border-box;
					opacity: 0.85;
					line-height: 36px;
					color: #ffffff;
					font-size: 24px;
					font-family: PingFang SC;
					text-align: left;
					word-break: break-all;
					background: linear-gradient(0deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
				}
			}
		}

		.material-item:nth-child(1) {
			margin-left: 0px;
		}

		.material-item:last-child {
			margin-right: 0px;
		}
	}

	.material-share {
		position: relative;
		padding-bottom: 20px;
		display: inline-block;
		width: 100%;
		min-height: 100px;
		text-align: center;

		.dividing-line {
			margin-top: calc(var(--proportion) * 120px);
		}

		.title {
			font-size: 1.45rem;
			width: 100%;
			line-height: 1;

			color: #ffffff;
			font-weight: 500;
			opacity: 0.85;
			margin-bottom: calc(var(--proportion) * 24px);
		}

		.label {
			font-size: 0.84rem;
			line-height: 1;

			font-weight: 500;
			color: #ffffff;
			opacity: 0.3;
		}

		.material-share-list {
			margin: 0px auto;
			margin-top: calc(var(--proportion) * 64px);
			// margin-left: calc(var(--proportion) * 60px);
			box-sizing: border-box;
			width: calc(var(--proportion) * 1800px);
			// display: flex;
			// justify-content: flex-start;
			// align-items: center;
			// flex-wrap: wrap;

			// .material-share-item:nth-child(1) {
			//   margin-left: 0px;
			//   margin-right: calc(var(--proportion) * 12px);
			// }

			// .material-share-item:nth-child(4n + 1) {
			//   margin-left: 0px;
			//   margin-right: calc(var(--proportion) * 12px);
			// }

			.material-share-item:nth-child(4n) {
				margin-right: 0px;
			}
			.list_box {
				display: flex;
				--list_box: calc(var(--proportion) * 1800px);
				justify-content: flex-start;
				align-items: center;
				flex-wrap: wrap;
			}

			// .material-share-item:nth-child(1) {
			//   display: flex;
			//   justify-content: flex-start;
			// }
			// .material-share-item:nth-child(4n-3) {
			//   display: flex;
			//   justify-content: flex-start;
			// }
			/*     .material-share-item:nth-child(4n) {
      display: flex;
      justify-content: flex-end;
    } */

			.material-share-item {
				--shareitem_width: calc(var(--proportion) * 430px);
				--marginright: calc(var(--proportion) * 80px);
				margin-right: calc(var(--proportion) * 26.666px);
				margin-bottom: calc(var(--proportion) * 28px);
				// flex: 1;
				// max-width: calc(25% - 24px);
				min-height: calc(var(--proportion) * 340px);
				width: var(--shareitem_width);
				flex-grow: 0;
				flex-shrink: 0;
				cursor: pointer;
				.material-share-img {
					position: relative;
					margin-bottom: calc(var(--proportion) * 24px);
					overflow: hidden;
					width: calc(var(--proportion) * 430px);
					height: calc(var(--proportion) * 330px);

					.share-img.hover {
						transform: scale(1.1);
					}

					.share-img {
						display: inline-block;
						width: 100%;
						height: 100%;
						transition: all 0.6s;
					}

					.material-share-popup {
						position: absolute;
						top: 0px;
						left: 0px;
						width: 100%;
						height: 100%;
						background: rgba(0, 0, 0, 0.5);
						display: flex;
						justify-content: center;
						align-items: center;
						flex-direction: column;

						.title {
							margin-bottom: calc(var(--proportion) * 32px);
							font-size: 0.85rem;
							padding: 0 24px;
							line-height: calc(0.85rem * 1.5);
							// font-weight: bold;
							color: #ffffff;
						}

						.btn-download:hover {
							opacity: 0.9;
						}

						.btn-download {
							display: flex;

							justify-content: center;
							align-items: center;
							width: 114px;
							height: 48px;
							font-size: 16px;
							// background: #e60000;
							border: 1px solid #ffffff;
							opacity: 0.85;

							font-weight: 500;
							color: #ffffff;
							cursor: pointer;

							.btn-download-img {
								position: relative;
								top: 1.4px;
								margin-left: 7px;
								width: 11px;
								height: 12px;
							}
						}
					}
				}

				.material-share-title {
					margin-bottom: calc(var(--proportion) * 14px);
					text-align: left;
					text-overflow: ellipsis;
					overflow: hidden;
					white-space: nowrap;
					font-size: 0.6rem;
					line-height: 1;
					width: calc(var(--proportion) * 417px);
					// font-weight: bold;
					color: rgba(255, 255, 255, 0.85);
				}

				.material-share-label {
					text-align: left;
					text-overflow: ellipsis;
					overflow: hidden;
					white-space: nowrap;
					font-size: 0.48rem;
					line-height: 1;

					font-weight: 400;
					color: rgba(255, 255, 255, 0.5);
					padding-bottom: 12px;
				}
			}
		}
	}

	.material-video-item:first-child {
		margin-left: 0px;
	}

	.material-video-item:last-child {
		margin-right: 0px;
	}

	.material-video-item {
		margin: 0px calc(var(--proportion) * 12px);
		margin-bottom: 20px;
		width: calc(var(--proportion) * 506px);
		min-height: calc(var(--proportion) * 288px);

		.material-video-img {
			position: relative;
			margin-bottom: calc(var(--proportion) * 30px);
			width: calc(var(--proportion) * 506px);
			height: calc(var(--proportion) * 288px);
			overflow: hidden;

			.video-img {
				width: 100%;
				height: 100%;
			}

			.open-popup {
				position: absolute;
				top: 0px;
				left: 0px;
				width: 100%;
				height: 100%;
				background-color: rgba(0, 0, 0, 0.8);
				display: flex;
				justify-content: center;
				align-items: center;

				img:hover {
					opacity: 0.6;
				}

				img {
					cursor: pointer;
					width: calc(var(--proportion) * 80px);
					height: calc(var(--proportion) * 80px);
				}
			}

			&:hover {
				.video-img {
					transform: scale(1.1);
				}
			}
		}

		.material-video-title {
			margin-bottom: calc(var(--proportion) * 10px);
			text-align: left;
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
			font-size: 0.6rem;

			// font-weight: bold;
			color: rgba(255, 255, 255, 0.85);
		}

		.material-video-label {
			text-align: left;
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
			font-size: 0.6rem;

			font-weight: 400;
			color: rgba(255, 255, 255, 0.5);
		}
	}

	.video-shelf {
		position: fixed;
		top: 0px;
		left: 0px;
		z-index: 9999;

		display: flex;
		justify-content: center;
		align-items: center;

		width: 100%;
		height: 100%;
		background-color: rgba(16, 15, 15, 0.7);

		.video {
			width: calc(var(--proportion) * 1280px);
			height: calc(var(--proportion) * 580px);
		}

		.video-shelf-close {
			position: absolute;
			top: calc(108px / var(--proportion));
			right: calc(var(--proportion) * 360px);
			width: 28px;
			height: 28px;
			cursor: pointer;
		}
	}

	@keyframes hover-round {
		0% {
			transform: scale(1);
			opacity: 1;
		}

		40% {
			transform: scale(1.1);
			opacity: 0.2;
		}

		80% {
			transform: scale(0.98);
			opacity: 0.8;
		}

		100% {
			transform: scale(1);
			opacity: 0;
		}
	}

	.dividing-line {
		display: none;
		position: relative;
		z-index: 4;
		margin: calc(var(--proportion) * 32px) auto;
		width: 40px;
		height: 2px;
		background: #e60000;
	}

	.swiper_box {
		width: calc(var(--proportion) * 1350px);
		height: 100%;
		.swiper_slide {
			width: calc(var(--proportion) * 1350px);
			height: 100%;
		}
	}
	// 轮播图导航
	::v-deep {
		.swiper-container {
			// width: 100%;
			height: 100% !important;
		}
		.swiper {
			--swiper-navigation-color: #cccccc25; /* 单独设置按钮颜色 */
			--swiper-navigation-size: 16px; /* 设置按钮大小 */
		}

		// element UI
		.el-carousel,
		.el-carousel__container {
			height: 100%;
		}
	}

	// 大字标题
	.headline {
		padding-top: calc(var(--proportion) * 148px);
		margin-bottom: calc(var(--proportion) * 48px) !important;
		// font-size: calc(var(--proportion) * 52px) !important;
		font-size: 28px !important;
		font-weight: 600 !important;
		letter-spacing: 4px;
	}
	// 小字副标题
	.small_caption {
		opacity: 0.7 !important;
		margin-bottom: calc(var(--proportion) * 92px) !important;
		font-weight: 'PingFang SC', Helvetica, 'Microsoft YaHei';
		// font-size: calc(var(--proportion) * 16px) !important;
		font-size: 15px !important;
		font-weight: 100 !important;
		line-height: 1 !important;
	}
	.mar-bottom {
		margin-bottom: calc(var(--proportion) * 48px) !important;
	}
	.mar-bottom92 {
		margin-bottom: calc(var(--proportion) * 92px) !important;
	}

	// 下载提示
	.small-skylight {
		position: fixed;
		top: 70px;
		right: 160px;
		z-index: 9999;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 6px;
		width: 70px;
		height: 70px;
		border-radius: 50%;
		background-color: #fff;
		box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.4);

		animation-name: tilt-in-bl;
		animation-duration: 1s;
		animation-timing-function: ease;
		animation-delay: 0s;
		animation-iteration-count: 1;
		animation-direction: normal;
		animation-fill-mode: none;
	}

	@keyframes tilt-in-bl {
		0% {
			transform: rotateY(35deg) rotateX(-20deg) translate(-250px, 250px) skew(-12deg, -15deg);
			opacity: 0;
		}
		100% {
			transform: rotateY(0) rotateX(0deg) translate(0, 0) skew(0deg, 0deg);
			opacity: 1;
		}
	}
</style>
